import { render, staticRenderFns, recyclableRender, components } from "./u-avatar.vue?vue&type=template&id=d3651d6e&scoped=true&"
var renderjs
import script from "./u-avatar.vue?vue&type=script&lang=js&"
export * from "./u-avatar.vue?vue&type=script&lang=js&"
import style0 from "./u-avatar.vue?vue&type=style&index=0&id=d3651d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3651d6e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-avatar/u-avatar.vue"
export default component.exports